export default __webpack_public_path__ + "static/media/logo-square.f988ed2b.svg";